<section class="license-capacity-modal">
  <div class="header">
    <span class="icon-bg">
      <evc-icon
        class="icon"
        icon="users"
        size="md" />
    </span>
    <p class="license-usage">{{ ('auth-license-capacity-modal.usage' | platformTranslate)() }}</p>
    <p class="description">
      {{ ('auth-license-capacity-modal.description' | platformTranslate)() }}
    </p>
  </div>

  @if (organizations().length > 1) {
    <section>
      <div class="divider-bar"></div>
      <p class="subtitle">
        {{ ('auth-license-capacity-modal.switch_organization' | platformTranslate)() }}
      </p>
      @for (org of organizations(); track org.id) {
        <evc-menu-item
          [badgeItem]="org"
          [aditionalText]="org.additionalText"
          [disabled]="!org.hasAccess"
          (organizationClicked)="orgSelected.emit($event.id)" />
      }
      <div class="divider-bar"></div>
    </section>
  }

  <evc-button
    [fullWidth]="true"
    type="primary"
    icon="home"
    [href]="homepage()"
    [text]="('auth-license-capacity-modal.go_to_dashboard' | platformTranslate)()" />
</section>
